import React from 'react';
import { getPathName } from '../utils/pathCalculations';
import '../../../styles/modes/compareMode.css';

const PathInfoDisplay = ({ pathInfo, path, locations, type }) => {
  return (
    <div className={`path-info ${type} ${!pathInfo ? 'empty' : ''}`}>
      <h5>{type === 'auto' ? 'Auto Path (Algorithm Solution)' : 'Custom Path (Manual Planning)'}</h5>
      {pathInfo ? (
        <>
          <p className="distance-value">{pathInfo.distance.toFixed(2)} km</p>
          <p>Contains {pathInfo.pointCount} points</p>
          <div className="path-sequence">
            <p>Path Sequence:</p>
            <div className="path-sequence-value">{getPathName(path, locations)}</div>
          </div>
        </>
      ) : (
        <p className="empty-message">
          {type === 'custom' 
            ? 'No confirmed custom path. Please create and confirm a path in Custom Path mode.'
            : `No ${type} path data`
          }
        </p>
      )}
    </div>
  );
};

export default PathInfoDisplay; 